import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Search } from "../../shared/Search";
import { Fetch } from "../../shared/Fetch";
import { IModel } from "./TestingEmailSetting";
import { IPermissionProps } from "../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { ITestingEmail } from "../../models/TestingEmailSetting";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,

}


export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITestingEmail>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [activeIndex, setActiveIndex] = useState<number | number[]>([0]);
    const handleCollapseAll = () => {
        setActiveIndex([]);
    };

    const handleExpandAll = () => {
        setActiveIndex([0, 1, 2, 3, 4, 5]);
    };

    

    useEffect(() => {
        loadTableData();

    }, [globalFilter, props.reload]);
    const dt = useRef<any>(null);
    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Testing_Email_Settings", "GET", null, `search=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<ITestingEmail> = await response.json();
            setTableData({ tableData: data, loading: false });

        }
    }
    const openEdit = () => {
        props.setModal({ open: true, singleData: tableData.tableData[0] });
    };
    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Website Setting</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const rightToolbarTemplate = () => {
        return <Button label="Update" icon="pi pi-pencil" className="p-button-success mr-2 bg-primary" onClick={openEdit} />
    }

    const leftToolbarTemplate = () => {
        return <>
            <Button label="Expand All" className="p-button-success mr-2 bg-primary" onClick={handleExpandAll} />
            <Button label="Collapse All" className="p-button-success mr-2 bg-primary" onClick={handleCollapseAll} />
        </>
    }

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
                
                <AccordionTab header="Test Email Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="sales_Email" header="Sales Email" />
                        <Column field="recruiter_Email" header="Recruiter Email" />
                        <Column field="sales_Head_Email" header="Sales Head Email" />
                        <Column field="recruiter_Head_Email" header="Recruiter Head Email" />
                        <Column field="branch_Head_Email" header="Branch Head Email" />
                        <Column field="consultant_Email" header="Consultant Email" />
                       
                    </DataTable>
                </AccordionTab>

            
               
               
            </Accordion>
        </>
    );
}

